import React, { memo } from 'react';

import { CellRendererProps } from '../../DataTable.types';

import ActionButton from '../../../ActionButton/ActionButton';

export const ActionCellRenderer: React.FC<CellRendererProps> = memo(
    ({ row, rowIndex, dynamicProps }) => {
        const { handleActionClick, openActionRowIndex, onToggleDropdown } = dynamicProps ?? {};

        return (
            <ActionButton
                rowIndex={rowIndex}
                row={row}
                handleActionClick={handleActionClick}
                isOpen={openActionRowIndex === rowIndex}
                onToggleDropdown={() => onToggleDropdown(rowIndex)}
            />
        );
    },
    (prevProps, nextProps) => {
        // Only re-render if the rowIndex or openActionRowIndex changes
        return (
            prevProps.rowIndex === nextProps.rowIndex &&
            prevProps.dynamicProps?.openActionRowIndex === nextProps.dynamicProps?.openActionRowIndex
        );
    },
);
